const plNames = {
    'names.people.first': 'Janek|Kasia|Wojtek|Basia|Piotrek|Zosia|Pawel|Hania|Olek|Ula|Jarek|Maja',
    'names.people.last':
        'Kowalski|Nowak|Zajac|Wrona|Lis|Kret|Mlynarz|Sosna|Kamyk|Kisiel|Mak|Bocian',
    'names.settlement.adjectives':
        'Bursztynowy|Żelazny|Kamienny|Srebrny|Złoty|Mroźny|Kruczy|Cienisty|Szafirowy|Perłowy|Wilczy|Smoczy|Orli|Dębowy|Cichy|Płomienny|Nocny|Biały|Czarny|Zielony|Księżycowy|Gwiezdny|Stalowy|Mglisty|Burzowy|Popielny|Słoneczny|Koralowy|Granitowy|Zimowy',
    'names.settlement.nouns':
        'Brzeg|Gród|Most|Przystań|Trakt|Straż|Bastion|Gaj|Zatoka|Twierdza|Jar|Brama|Szczyt|Dwór|Port|Zamek|Wieża|Dolina|Kamień|Szlak|Zdrój|Rynek|Furta|Mur|Szaniec|Fort|Strażnica|Bród|Próg|Baszta',
};

export default plNames;
